import { render, staticRenderFns } from "./epms5080.vue?vue&type=template&id=5b55cd82&scoped=true"
import script from "./epms5080.vue?vue&type=script&lang=js"
export * from "./epms5080.vue?vue&type=script&lang=js"
import style0 from "./epms5080.vue?vue&type=style&index=0&id=5b55cd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55cd82",
  null
  
)

export default component.exports